import React, { useState } from "react";
import MatricularMoodle from "./MatricularMoodle";

const ModalMatricular = () => {

  const [open, setOpen] = useState(false);

  return (
    <div>

      <button onClick={() => setOpen(true)}>
        Matricular en Moodle
      </button>

      {open && (
        <div style={styles.overlay}>

          <div style={styles.modal}>

            <div style={styles.header}>
              <h3>Matricular Usuarios</h3>

              <button
                onClick={() => setOpen(false)}
                style={styles.close}
              >
                ✖
              </button>
            </div>

            <div style={styles.body}>
              <MatricularMoodle />
            </div>

          </div>

        </div>
      )}

    </div>
  );
};

const styles = {

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },

  modal: {
    background: "#fff",
    padding: 20,
    borderRadius: 8,
    width: "800px",
    maxHeight: "80vh",
    overflowY: "auto"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10
  },

  body: {
    marginTop: 10
  },

  close: {
    border: "none",
    background: "red",
    color: "white",
    padding: "5px 10px",
    cursor: "pointer"
  }

};

export default ModalMatricular;